"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidStringLength = exports.getTrackDimensions = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));
var _token = require("./../_utils/token");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Verifies that a string provided to the `trackLength` prop is valid.
 * Currently we only support px, em, rem, vw, and vh.
 *
 * 9.x TODO: allow percentage values in 9.x.
 * Currently percentage widths are not supported due to our center alignment hack for labels and step children of horizontal rows.
 * They have a forced width equal to the width of the milestone diameter to center their content. A percentage width
 * of the milestone diameter width.
 */
var isValidStringLength = function isValidStringLength(length) {
  var lengthRegex = /^\d+(px|em|rem|vh|vw)$/i;
  return lengthRegex.test(length);
};
exports.isValidStringLength = isValidStringLength;
var trackStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _objectSpread2;
  var autoTrackLength = _ref.autoTrackLength,
    direction = _ref.direction,
    lengthInPx = _ref.lengthInPx,
    widthInPx = _ref.widthInPx,
    neutral = _ref.neutral,
    minLength = _ref.minLength,
    spacingInset = _ref.spacingInset,
    type = _ref.type;
  var isPartial = type === "present";
  var isRow = direction === "row";

  // Sets the appropriate thickness of the track based on the direction
  var trackThickness = (0, _defineProperty2["default"])({}, isRow ? "height" : "width", widthInPx);

  // Sets the appropriate styles for the complete track
  var completeTrackStyles = {
    "& [mdn-progress-tracker-complete]": _objectSpread({
      backgroundColor: t("trackBackgroundColorComplete", neutral ? "neutral" : "theme"),
      borderRadius: t("trackBorderRadius"),
      border: "".concat(t("trackBorderWidth"), "px solid ").concat(t("trackBorderColor", neutral ? "neutral" : "theme")),
      flex: "auto",
      zIndex: 1
    }, trackThickness)
  };

  // Sets the appropriate styles for the incomplete track
  var incompleteTrackStyles = {
    "& [mdn-progress-tracker-incomplete]": _objectSpread((_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, isRow ? "marginInlineStart" : "marginTop", isPartial ? -spacingInset : undefined), (0, _defineProperty2["default"])(_objectSpread2, "backgroundColor", t("trackBackgroundColorIncomplete", neutral ? "neutral" : "theme")), (0, _defineProperty2["default"])(_objectSpread2, "borderRadius", t("trackBorderRadius")), (0, _defineProperty2["default"])(_objectSpread2, "border", "".concat(t("trackBorderWidth"), "px solid ").concat(t("trackBorderColor", neutral ? "neutral" : "theme"))), (0, _defineProperty2["default"])(_objectSpread2, "flex", "auto"), (0, _defineProperty2["default"])(_objectSpread2, "zIndex", 0), _objectSpread2), trackThickness)
  };
  return (0, _css.css)(_objectSpread(_objectSpread({
    display: "flex",
    flexDirection: direction,
    alignItems: "center"
  }, completeTrackStyles), incompleteTrackStyles), autoTrackLength ? {
    // Only add flexGrow if autoTrackLength is true
    flexGrow: 1
  } : (0, _defineProperty2["default"])({}, isRow ? "width" : "height", isValidStringLength(lengthInPx) ? lengthInPx : lengthInPx - 2 * spacingInset), isRow ? {
    // Set minWidth and margins for row progress trackers
    minWidth: minLength,
    marginInlineStart: spacingInset,
    marginInlineEnd: spacingInset
  } : {
    // Set minHeight and margins for column progress trackers
    minHeight: minLength,
    marginTop: spacingInset,
    marginBottom: spacingInset
  });
}, ["autoTrackLength", "direction", "lengthInPx", "widthInPx", "neutral", "type", "minLength", "spacingInset"]);
var getTrackDimensions = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var length = _ref3.length,
    size = _ref3.size;
  var widthInPx = t("trackWidth", size);
  var defaultLength = "".concat(t("trackLengthDefault"), "px");
  if (length === "auto") {
    return {
      lengthInPx: "auto",
      widthInPx: widthInPx
    };
  } else if (typeof length === "string") {
    return {
      lengthInPx: isValidStringLength(length) ? length : defaultLength,
      widthInPx: widthInPx
    };
  } else {
    // 9.x TODO: Remove dot support for trackLength in 9.x
    var lengthInDots = 2 * Math.round(length / 2);
    return {
      lengthInPx: lengthInDots * (widthInPx * 2) + widthInPx,
      widthInPx: widthInPx
    };
  }
}, ["length", "size"]);
exports.getTrackDimensions = getTrackDimensions;
var Track = function Track(props) {
  var autoTrackLength = props.autoTrackLength,
    direction = props.direction,
    length = props.length,
    neutral = props.neutral,
    size = props.size,
    type = props.type;
  var _useContext = (0, _react.useContext)(_progressTrackerContext["default"]),
    t = _useContext.t;
  var _getTrackDimensions = getTrackDimensions(t, {
      length: length,
      size: size
    }),
    lengthInPx = _getTrackDimensions.lengthInPx,
    widthInPx = _getTrackDimensions.widthInPx;

  // Get the min track length and spacing horizontal tokens
  var minLength = t("trackLengthMinimum", size);
  var spacingInset = t("spacing", size);
  var displayCompletedTrack = props.type === "past" || props.type === "present";
  var displayIncompleteTrack = props.type === "present" || props.type === "future";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: trackStyles(t, {
      autoTrackLength: autoTrackLength,
      direction: direction,
      lengthInPx: lengthInPx,
      widthInPx: widthInPx,
      neutral: neutral,
      minLength: minLength,
      spacingInset: spacingInset,
      type: type
    })
  }, displayCompletedTrack ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-progress-tracker-complete": ""
  }) : null, displayIncompleteTrack ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-progress-tracker-incomplete": ""
  }) : null);
};
Track.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Whether or not to ignore the length prop and auto fit the track length
   * to the height of the content provided as children to the ProgressTrackerStep
   * component.
   */
  autoTrackLength: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOf(["row", "column"]),
  /**
   * Use this to adjust the step's track length.
   *
   * Number values support the number of "dots" that make up the track. Only even numbers are supported; odd numbers will round up.
   * String values support the following units: px, rem, em, vh, and vw.
   *
   * Track length of "auto" will behave differently for row and column progress trackers:
   * - For column progress trackers the height of steps grow to fit the content of their children elements.
   * - For row progress trackers, the width of steps will grow equally to fill the parent container width.
   *
   * Note: The length can only be set to auto when autoTrackLength is set to `true`
   * on the parent ProgressTracker component.
   */
  length: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  neutral: _propTypes["default"].bool,
  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "large"]),
  type: _propTypes["default"].oneOf(["past", "present", "future"])
} : {};
var _default = Track;
exports["default"] = _default;